const API_BASE = process.env.VUE_APP_API_BASE || 'https://tyng-ca.com.my'

let cachedKey = null

async function loadPublicKey () {
  if (cachedKey) return cachedKey

  const res = await fetch(`${API_BASE}/api/public-key.php`)
  if (!res.ok) throw new Error('Failed to fetch encryption key')
  const { key } = await res.json()
  if (!key) throw new Error('Invalid encryption key response')

  const b64 = key.replace(/-----[^-]+-----/g, '').replace(/\s+/g, '')
  const der = Uint8Array.from(atob(b64), c => c.charCodeAt(0))

  cachedKey = await crypto.subtle.importKey(
    'spki',
    der.buffer,
    { name: 'RSA-OAEP', hash: 'SHA-1' },
    false,
    ['encrypt']
  )

  return cachedKey
}

export async function encryptPassword (password) {
  const key = await loadPublicKey()
  const encoded = new TextEncoder().encode(password)
  const encrypted = await crypto.subtle.encrypt({ name: 'RSA-OAEP' }, key, encoded)
  return btoa(String.fromCharCode(...new Uint8Array(encrypted)))
}
